import { SceneComponentConstants } from "../sceneComponent";
/**
 * Defines the layer scene component responsible to manage any layers
 * in a given scene.
 */
var LayerSceneComponent = /** @class */ (function () {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */
    function LayerSceneComponent(scene) {
        /**
         * The component name helpfull to identify the component in the list of scene components.
         */
        this.name = SceneComponentConstants.NAME_LAYER;
        this.scene = scene;
        this._engine = scene.getEngine();
        scene.layers = new Array();
    }
    /**
     * Registers the component in a given scene
     */
    LayerSceneComponent.prototype.register = function () {
        this.scene._beforeCameraDrawStage.registerStep(SceneComponentConstants.STEP_BEFORECAMERADRAW_LAYER, this, this._drawCameraBackground);
        this.scene._afterCameraDrawStage.registerStep(SceneComponentConstants.STEP_AFTERCAMERADRAW_LAYER, this, this._drawCameraForeground);
        this.scene._beforeRenderTargetDrawStage.registerStep(SceneComponentConstants.STEP_BEFORERENDERTARGETDRAW_LAYER, this, this._drawRenderTargetBackground);
        this.scene._afterRenderTargetDrawStage.registerStep(SceneComponentConstants.STEP_AFTERRENDERTARGETDRAW_LAYER, this, this._drawRenderTargetForeground);
    };
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */
    LayerSceneComponent.prototype.rebuild = function () {
        var layers = this.scene.layers;
        for (var _i = 0, layers_1 = layers; _i < layers_1.length; _i++) {
            var layer = layers_1[_i];
            layer._rebuild();
        }
    };
    /**
     * Disposes the component and the associated ressources.
     */
    LayerSceneComponent.prototype.dispose = function () {
        var layers = this.scene.layers;
        while (layers.length) {
            layers[0].dispose();
        }
    };
    LayerSceneComponent.prototype._draw = function (predicate) {
        var layers = this.scene.layers;
        if (layers.length) {
            this._engine.setDepthBuffer(false);
            for (var _i = 0, layers_2 = layers; _i < layers_2.length; _i++) {
                var layer = layers_2[_i];
                if (predicate(layer)) {
                    layer.render();
                }
            }
            this._engine.setDepthBuffer(true);
        }
    };
    LayerSceneComponent.prototype._drawCameraPredicate = function (layer, isBackground, cameraLayerMask) {
        return !layer.renderOnlyInRenderTargetTextures &&
            layer.isBackground === isBackground &&
            ((layer.layerMask & cameraLayerMask) !== 0);
    };
    LayerSceneComponent.prototype._drawCameraBackground = function (camera) {
        var _this = this;
        this._draw(function (layer) {
            return _this._drawCameraPredicate(layer, true, camera.layerMask);
        });
    };
    LayerSceneComponent.prototype._drawCameraForeground = function (camera) {
        var _this = this;
        this._draw(function (layer) {
            return _this._drawCameraPredicate(layer, false, camera.layerMask);
        });
    };
    LayerSceneComponent.prototype._drawRenderTargetPredicate = function (layer, isBackground, cameraLayerMask, renderTargetTexture) {
        return (layer.renderTargetTextures.length > 0) &&
            layer.isBackground === isBackground &&
            (layer.renderTargetTextures.indexOf(renderTargetTexture) > -1) &&
            ((layer.layerMask & cameraLayerMask) !== 0);
    };
    LayerSceneComponent.prototype._drawRenderTargetBackground = function (renderTarget) {
        var _this = this;
        this._draw(function (layer) {
            return _this._drawRenderTargetPredicate(layer, true, _this.scene.activeCamera.layerMask, renderTarget);
        });
    };
    LayerSceneComponent.prototype._drawRenderTargetForeground = function (renderTarget) {
        var _this = this;
        this._draw(function (layer) {
            return _this._drawRenderTargetPredicate(layer, false, _this.scene.activeCamera.layerMask, renderTarget);
        });
    };
    /**
     * Adds all the elements from the container to the scene
     * @param container the container holding the elements
     */
    LayerSceneComponent.prototype.addFromContainer = function (container) {
        var _this = this;
        if (!container.layers) {
            return;
        }
        container.layers.forEach(function (layer) {
            _this.scene.layers.push(layer);
        });
    };
    /**
     * Removes all the elements in the container from the scene
     * @param container contains the elements to remove
     * @param dispose if the removed element should be disposed (default: false)
     */
    LayerSceneComponent.prototype.removeFromContainer = function (container, dispose) {
        var _this = this;
        if (dispose === void 0) { dispose = false; }
        if (!container.layers) {
            return;
        }
        container.layers.forEach(function (layer) {
            var index = _this.scene.layers.indexOf(layer);
            if (index !== -1) {
                _this.scene.layers.splice(index, 1);
            }
            if (dispose) {
                layer.dispose();
            }
        });
    };
    return LayerSceneComponent;
}());
export { LayerSceneComponent };
//# sourceMappingURL=layerSceneComponent.js.map